(()=>{'use strict';
 const scrim=document.querySelector('[data-ov91-menu-scrim]');
 const nav=document.getElementById('ov2-menu');
 const toggle=document.getElementById('ov2-menu-toggle');
 if(!nav||!toggle)return;
 scrim?.addEventListener('click',()=>{if(nav.classList.contains('is-open'))toggle.click();});
 // Browser focus should not disappear behind the panel while open.
 nav.addEventListener('keydown',event=>{
  if(event.key!=='Tab'||!nav.classList.contains('is-open'))return;
  const focusables=[...nav.querySelectorAll('a[href],button:not([disabled])')].filter(el=>el.getClientRects().length>0);
  if(!focusables.length)return;
  const first=focusables[0],last=focusables[focusables.length-1];
  if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
  else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
 });
})();

